const ReactDOM = require('react-dom');

function isObject(input) {
    if (!input) {
        return false;
    }

    return !Array.isArray(input) && typeof input === 'object';
}

/**
* Decimal adjustment of a number.  Code source:
* https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/floor
* @param {String}  type  The type of adjustment.
* @param {Number}  value The number.
* @param {Integer} exp   The exponent (the 10 logarithm of the adjustment base).
* @returns {Number} The adjusted value.
*/
function decimalAdjust(type, value, exp) {
    // If the exp is undefined or zero...
    if (typeof exp === 'undefined' || +exp === 0) {
        return Math[type](value);
    }
    value = +value;
    exp = +exp;
    // If the value is not a number or the exp is not an integer...
    if (isNaN(value) || !(typeof exp === 'number' && exp % 1 === 0)) {
        return NaN;
    }
    // Shift
    value = value.toString().split('e');
    value = Math[type](+(value[0] + 'e' + (value[1] ? (+value[1] - exp) : -exp)));
    // Shift back
    value = value.toString().split('e');
    return +(value[0] + 'e' + (value[1] ? (+value[1] + exp) : exp));
}

function decimalFloor(value, exp) {
    return decimalAdjust('floor', value, exp);
}

function titleCase(string) {
    return string.toLowerCase()
        .split(' ')
        .map(function (value) {
            return value.charAt(0).toUpperCase() + value.slice(1);
        })
        .join(' ');
}

function removeDuplicatesInArray(array, key) {
    if (!(array instanceof Array) || key && typeof key !== 'string') {
        return false;
    }

    if (key && typeof key === 'string') {
        return array.filter((obj, index, arr) => {
            return arr.map(mapObj => mapObj[key]).indexOf(obj[key]) === index;
        });
    } else {
        return array.filter(function (item, index, arr) {
            return arr.indexOf(item) === index;
        });
    }
}

// Do not use this. This is deprecated, and we dont want to hardcode offsets
// Please use UI.scrollTo instead
function scrollTo(findNode, querySelector, offSetMobile = 0, offSetDesktop = 0) {
    const node = findNode ?
        querySelector ? ReactDOM.findDOMNode(findNode).querySelector(querySelector) :
            ReactDOM.findDOMNode(findNode) :
        document.querySelector(querySelector);

    if (node) {
        const yAxis = node.getBoundingClientRect().top + window.scrollY;
        window.scroll({
            top: yAxis - (Sephora.isMobile() ? offSetMobile : offSetDesktop),
            behavior: 'smooth'
        });
    }
}

function getProp(obj, path, defaultVal) {
    const property = path.split('.').reduce((object, prop) =>
        (typeof object === 'undefined' || object === null) ? object : object[prop], obj);

    return property === undefined || property === null ? defaultVal : property;
}

function replaceDoubleAsterisks(str) {
    return str.replace(/\*\*/gi, '*');
}

const specialCharacterRegex = /[^\d]*/gi;

module.exports = {
    isObject,
    decimalFloor,
    titleCase,
    removeDuplicatesInArray,
    specialCharacterRegex,
    scrollTo,
    getProp,
    replaceDoubleAsterisks
};
